<template>
    <vs-popup classContent="popup-example"  title="ویرایش اطلاعات کاربر" :active.sync="showPopup">
        <div class="vx-col w-full mb-base" @keydown.enter="updateUserInfo()">
            <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                        class="w-full"
                        icon-pack="feather"
                        icon="icon-user"
                        icon-no-border
                        label-placeholder="نام"
                        v-model="editUser.name"
                    />
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                        class="w-full"
                        icon-pack="feather"
                        icon="icon-user"
                        icon-no-border
                        label-placeholder="نام خانوادگی"
                        v-model="editUser.last_name"
                    />
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                        class="w-full"
                        icon-pack="feather"
                        icon="icon-smartphone"
                        icon-no-border
                        label-placeholder="شماره موبایل"
                        v-model="editUser.phone_number"
                    />
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                        name="email"
                        class="w-full"
                        icon-pack="feather"
                        icon="icon-mail"
                        icon-no-border
                        label-placeholder="ایمیل"
                        v-model="editUser.email"
                    />
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary is-label-placeholder">
                        <div class="vs-con-input">
                            <pdatepicker
                                :placeholder="editUser.birth_date"
                                header-background-color="#fb8103"
                                hover-day-back-color="#fb8103"
                                chosen-day-back-color="#fb8103"
                                class="vs-inputx vs-input--input hasValue hasIcon"
                                style="border : 1px solid rgba(0, 0, 0, 0.2)"
                                v-model="editUser.birth_date"								
                            ></pdatepicker>
                            <!-- <span class="input-span-placeholder vs-input--placeholder normal normal vs-placeholder-label">
                                تاریخ تولد
                            </span> -->
                            <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-calendar null icon-no-border"></i>
                        </div>
                        <span></span>
                    </div>
                    <span class="text-danger text-sm"></span>
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                        name="city"
                        class="w-full"
                        icon-pack="feather"
                        icon="icon-map-pin"
                        icon-no-border
                        label-placeholder="شهر"
                        v-model="editUser.city"
                    />
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                        name="stat"
                        class="w-full"
                        icon-pack="feather"
                        icon="icon-map-pin"
                        icon-no-border
                        label-placeholder="استان"
                        v-model="editUser.state"
                    />
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary is-label-placeholder">
                        <!-- <span class="input-span-placeholder vs-input--placeholder normal normal vs-placeholder-label">
                            جنسیت
                        </span> -->
                        <v-select :options="options" v-model="gender" :clearable="false" />
                    </div>
                    <span class="text-danger text-sm"></span>
                </div>
                
            </div>
            <div class="vx-row">
                
            </div>

            <div class="vx-row mt-4">
                <div class="vx-col w-full">
                    <vs-button class="mr-3 mb-2 float-right" @click="updateUserInfo()" :disabled="!validateForm">ثبت</vs-button>
                </div>
            </div>
    
        </div>
    </vs-popup>
</template>

<script>
import vSelect from 'vue-select'

export default {
    name: 'EditUser',

    props: {
        popupEditUser: {
            type: Boolean,
            default: false,
        },
        userId: Number
    },
    
    components: {
        vSelect,
    },

    computed: {
        validateForm() {
            return this.editUser.name != '' && this.editUser.last_name != '' && this.editUser.phone_number != '';
        },
    },
    
    data() {
		return{
            showPopup: false,
            editUser: {
                name: '',
                last_name: '',
                phone_number: '',
                email: '',
                birth_date: '',
                city: '',
                state: '',
                gender: {
					label: 'آقا',
					value: 'male',
				},
            },
            gender: { label: '', value: ''},
            options: [
				{
					label: 'آقا',
					value: 'male',
				},
				{
					label: 'خانم',
					value: 'female',
				},
			]
		}
    },

    watch: {
        gender(obj) {
      		this.editUser.gender= obj.value
        },
        
      	popupEditUser: function(newVal) {
            this.showPopup = newVal
            if(newVal == true){
                this.$vs.loading()
                this.$store.dispatch('getUserInfo', this.userId)
                .then(res => {
                    this.editUser = res.data
                    if(this.editUser.gender === 'female'){
                        this.gender.label = 'خانم',
                        this.gender.value = 'female'
                    }
                    else{
                        this.gender.label = 'آقا',
                        this.gender.value = 'male'
                    }
                    if (this.editUser.birth_date === null) {
                        this.editUser.birth_date = "0000/00/00";
                    }
                    else {
                        this.editUser.birth_date = this.editUser.birth_date.replace(/-/g, "/");
                    }
                    this.$vs.loading.close()
                }).catch(() => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: '',
                        text: 'خطا در اتصال به اینترنت',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    })
                })
            }
        },

        showPopup: function(newVal) {
            this.$emit('updatePopupEditUser', newVal)
            this.editUser = {
                name: '',
                last_name: '',
                phone_number: '',
                email: '',
                birth_date: '',
                city: '',
                state: '',
                gender: {
					label: 'آقا',
					value: 'male',
				},
                password: ''
            }
        },
    },

    created(){	
    },
    
    methods: {
        updateUserInfo(){
			let birth_date = ''
			if(this.editUser.birth_date === "0000/00/00"){
				birth_date = ''
			}
			else{
				birth_date = this.editUser.birth_date
			}
			let user = {
				id : this.editUser.id,
				name : this.editUser.name,
				last_name : this.editUser.last_name,
				phone_number : this.editUser.phone_number,
				email : this.editUser.email,
				gender : this.gender.value,
				birth_date : birth_date,
				state : this.editUser.state,
				city : this.editUser.city,
			}
			this.editUser = {
                name: '',
                last_name: '',
                phone_number: '',
                email: '',
                birth_date: '',
                city: '',
                state: '',
                gender: {
					label: 'آقا',
					value: 'male',
				},
                password: ''
            },
            this.$vs.loading()
            this.$emit('updatePopupEditUser', false)
			this.$store.dispatch('updateUserInfo', user)
			.then(() => {
				this.$vs.loading.close()
				this.$vs.notify({
					title: '',
					text: 'اطلاعات کاربر با موفقیت ویرایش شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
			})
			.catch(() => {
				this.$vs.loading.close()
				this.$vs.notify({
				title: '',
				text: 'اطلاعات وارد شده صحیح نمی باشد.',
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'warning'
				})
			})
		},
    }
}
</script>

